const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInlaocitizen23',
    accessToken: 'accessTokenlaocitizen23',
    userRole: 'userRole23',
  }
}

export default AppConfig;
